export const SCREEN_NAME = {
    PAYMENT: "payment",
    ADD_NEW_CARD: "add-new-card",
    ADD_NEW_CARD_PAYMENT_MODES: "add-new-card-pm",
    MANAGE_CARD_PAYMENT_MODES: "manage-card-pm",
    PAYMENT_FAILURE_DIALOG: "payment-failure-dialog",
    ORDER_TERMINAL_STATE_ALERT: "order-terminal-state-alert",
    AUTOPAY_PAYMENT_FAILURE_SCREEN: "autoplace",
    PAYMENT_CONFIRMATION: "payment-confirmation-screen",
    LINK_WALLET_OTP: "link-wallet-otp",
    UPI_TIMER: "upi-timer",
    UPI_INTENT_POLLER: "upi-intent-poller",
    SWIGGY_MONEY_PAYMENTS: "swiggy-money-payments",
    SWIGGY_MONEY_TOPUP_PAGE: "swiggy-money-topup-page",
    SWIGGY_MONEY_SUCCESS_SCREEN: "swiggy-money-success-screen",
    PAYMENT_HALF_CARD: "payment-half-card",
    PAYMENT_MODES: "payment-modes",
    SWIGGY_UPI: "swiggy-upi",
    PAY_ON_DELIVERY_PAYMENT_SUCCESS_SCREEN: "autopay-success",
    PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE_SCREEN: "autopay-prev-half-card",
    PAY_ON_DELIVERY_PAST_PAYMENT_PENDING_SCREEN: "autopay-pending-half-card",
    PAY_ON_DELIVERY_MAX_PAYMENT_RETRIES_SCREEN: "autopay-failure-half-card",
    ADD_MONEY: "add-money",
    WALLET_VIEW: "wallet-view",
    PAY_ON_DELIVERY_MAX_PAYMENT_RETRIES_SOFT_FAILURE_SCREEN: "autoplace-halfcard",
    SWIGGY_MONEY: "swiggy-money-page",
    CHECKOUT: "checkout",
    COUPON_LISTING: "food-apply-coupon",
    EMI_SELECTION: "payment-emi",
    REVIEW_BILL_DETAILS: "payment-review",
};
